<!-- eslint-disable -->
<template lang="pug">
    .row.homework
        .col-xs-12.homework__info
            .homework__left-column
                router-link.homework__date(:to="{name: 'homework:edit', params: {id: homework.id, type: 'homework'}}")
                    | {{ $i18n.t('profiles.profiles_userHomeworkPreview_taskOn') }}
                    | {{ homework.date | moment('DD.MM.YYYY') }}
                .games-caret(@click="showGames = !showGames")
                    | {{ $i18n.t('profiles.profiles_userHomeworkPreview_games') }}
                    svg-icon.angle__icon(
                        name="angle", height="9px", width="14px",
                        :class="{'angle__icon--inverse': showGames}"
                    )
            .homework__right-column
                cs-button(
                    v-if="!homework.pivot.isCompleted"
                    color="green"
                    pattern="primary-outline"
                    :loading="isLoading"
                    :disabled="!canCountHomework"
                    @click="countHomework"
                )
                    | {{ $i18n.t('profiles.profiles_userHomeworkPreview_countTask') }}
                .homework__done(v-else)
                    svg-icon.homework__done-icon(name="circle-check", size="x-large")
                    | {{ $i18n.t('profiles.profiles_userExercisePreview_done') }}
        .row.col-xs-12.exercises(v-show="showGames")
            .col-xs-12.col-md-6
                exercise-preview(
                    v-for="(exercise, index) in leftExercises"
                    :exercise="exercise"
                    :index="2*index"
                    :key="exercise.id"
                    :userId="viewedUserId"
                    @statUpdated="$emit('statUpdated', arguments[0], arguments[1], homeworkIndex)"
                )
            .col-xs-12.col-md-6
                exercise-preview(
                    v-for="(exercise, index) in rightExercises"
                    :exercise="exercise"
                    :index="2*index + 1"
                    :key="exercise.id"
                    :userId="viewedUserId"
                    @statUpdated="$emit('statUpdated', arguments[0], arguments[1], homeworkIndex)"
                )

</template>

<script>
    /*eslint-disable*/
    import ExercisePreview from './ExercisePreview.vue'
    import {difference} from 'lodash'
    import UserApi from "../../../api/user/user"

    export default {
        props: {
            homework: Object,
            user: Object,
            viewedUserId: Number,
            homeworkIndex: Number
        },
        data () {
            return {
                showGames: false,
                isLoading: false,
                leftExercises: [],
                rightExercises: []
            }
        },
        components: {
            ExercisePreview
        },
        mounted () {
            this.homework.exercises.forEach((exercise, index) => {
                index % 2 ? this.rightExercises.push(exercise) : this.leftExercises.push(exercise);
            });
        },
        methods: {
            countHomework () {
                this.isLoading = true;
                UserApi.countHomework(this.viewedUserId, this.homework.id)
                .then(homework => {
                    this.$emit('homeworkUpdated', this.homeworkIndex);
                    this.isLoading = false;
                })
                .catch(err => {
                    this.isLoading = false;
                    this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                })
            }
        },
        computed: {
            canCountHomework () {
                const homeworkGradesIds = this.homework.grades.map(grade => grade.id);
                const userGradesIds = this.user.grades.map(grade => grade.id);
                return this.user.isSuperadmin
                        || this.user.isManagerOrSupport
                        || (this.user.type === 'admin' && !difference([this.homework.schoolId], this.user.schoolsIds).length)
                        || !difference(homeworkGradesIds, userGradesIds).length;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .homework__info {
        display: flex;
        justify-content: space-between;
        margin-top: 30px;

        flex-direction: column;
        @include media($md) {
            flex-direction: row;
        }
    }

    .homework__date {
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
        margin-bottom: 20px;
        @include media($md) {
            margin-bottom: 0;
        }
    }

    .homework__left-column {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-bottom: 20px;
        @include media($md) {
            margin-bottom: 0;
        }
    }

    .homework__done {
        color: $hsl-color-green-58;
        display: flex;
        align-items: center;
        font-weight: 500;
        font-size: 16px;
        line-height: 51px;
    }

    .homework__done-icon {
        margin-right: 10px;
    }

    .angle__icon {
        margin-left: 8px;
        color: $hsl-color-blue-56;
    }

    .angle__icon--inverse {
        transform: rotate(0.5turn);
    }

    .games-caret:hover {
        cursor: pointer;
    }
</style>
